import { useState } from "react";
import { api } from "@/lib/api";
import { Tv, ShoppingBag, BookOpen, GraduationCap, User, ArrowRight, ArrowLeft, X, Sparkles } from "lucide-react";

const STEPS = [
  { icon: Tv, tab: "ponderr_tv", title: "Ponderr TV", body: "Watch live syllabus streams and academy broadcasts mapped to your board and grade." },
  { icon: ShoppingBag, tab: "storez", title: "Storez", body: "Shop district-scoped curriculum kits and study material — with Cash on Delivery available." },
  { icon: BookOpen, tab: "ponderr_learn", title: "Ponderr Learn", body: "Track Read2Lead reading logs, build master notes, and explore the Art Studio." },
  { icon: GraduationCap, tab: "lms", title: "Ponderr LMS", body: "Follow your board-aligned curriculum subjects, lessons and assessments." },
  { icon: User, tab: "my_space", title: "My Space & Drawers", body: "Manage your profile and personal Gemini key here. Swipe from the LEFT edge for your Daily Organiser and the RIGHT edge for your Ponderr Notebook + AI Tutor." },
];

export default function WelcomeTour({ onNavigateTab, onDone }) {
  const [i, setI] = useState(0);
  const step = STEPS[i];
  const Icon = step.icon;

  const finish = async () => {
    try { await api.post("/open-school/complete-tour"); } catch { /* ignore */ }
    onDone && onDone();
  };
  const go = (n) => {
    const next = Math.max(0, Math.min(STEPS.length - 1, n));
    setI(next);
    onNavigateTab && onNavigateTab(STEPS[next].tab);
  };

  return (
    <div className="fixed inset-0 z-[60] bg-black/60 grid place-items-center p-4" data-testid="welcome-tour">
      <div className="nb-card bg-white border-2 border-black max-w-md w-full p-6 space-y-4 shadow-[8px_8px_0_0_#C4B5FD]">
        <div className="flex items-center gap-2">
          <span className="nb-badge bg-[#C4B5FD] text-xs"><Sparkles size={12} /> Welcome to Ponderr</span>
          <button className="ml-auto" onClick={finish} data-testid="welcome-tour-skip"><X size={18} /></button>
        </div>
        <div className="w-14 h-14 rounded-xl bg-[#FDE047] border-2 border-black grid place-items-center shadow-[3px_3px_0_0_#000]">
          <Icon size={26} />
        </div>
        <h2 className="display text-2xl font-black" data-testid="welcome-tour-title">{step.title}</h2>
        <p className="text-sm text-slate-700">{step.body}</p>

        <div className="flex gap-1">
          {STEPS.map((_, idx) => (
            <div key={idx} className={`h-1.5 flex-1 rounded-full ${idx <= i ? "bg-[#C4B5FD]" : "bg-slate-200"}`} />
          ))}
        </div>

        <div className="flex items-center justify-between pt-1">
          <button className="nb-btn nb-btn-ghost text-sm" disabled={i === 0} onClick={() => go(i - 1)} data-testid="welcome-tour-back"><ArrowLeft size={14} /> Back</button>
          {i < STEPS.length - 1
            ? <button className="nb-btn text-sm" onClick={() => go(i + 1)} data-testid="welcome-tour-next">Next <ArrowRight size={14} /></button>
            : <button className="nb-btn text-sm" onClick={finish} data-testid="welcome-tour-finish">Start Exploring <Sparkles size={14} /></button>}
        </div>
      </div>
    </div>
  );
}
